// constants.ts

import { Box, Link, Typography } from "@mui/material";

// Chatbot Name
export const CHATBOT_WEBSITE_NAME = "GPSC Aura";

// ADMIN roles
export const PURCHASING_ADMIN_ROLE = "GPSC_Chatbot_Purchasing_Admin";
export const SQ_ADMIN_ROLE = "GPSC_Chatbot_SQ_Admin";
export const SUPPLYCHAIN_ADMIN_ROLE = "GPSC_Chatbot_SupplyChain_Admin";
export const DOMAIN_4_ADMIN_ROLE = "GPSC_Chatbot_Domain_4_Admin";
export const DOMAIN_5_ADMIN_ROLE = "GPSC_Chatbot_Domain_5_Admin";
export const DOMAIN_6_ADMIN_ROLE = "GPSC_Chatbot_Domain_6_Admin";


// NON_ADMIN roles
export const USER_ROLE = "GPSC_Chatbot_User";
export const IT_ROLE = "GPSC_Chatbot_IT";
export const NO_ACCESS_ROLE = "NoAccess";
export const NON_GPSC_USER_ROLE = "Non_GPSC_Chatbot_User";
export const ECR_AGENT_USER_ROLE = "GPSC_ECR_USER";
export const SUPPLYCHAIN_USER_ROLE = "GPSC_Chatbot_SupplyChain_User";
export const DOMAIN_4_USER_ROLE = "GPSC_Chatbot_Domain_4_User";

export const ADMIN_ROLES = [
    PURCHASING_ADMIN_ROLE,
    SQ_ADMIN_ROLE,
    SUPPLYCHAIN_ADMIN_ROLE,
    DOMAIN_4_ADMIN_ROLE,
    DOMAIN_5_ADMIN_ROLE,
    DOMAIN_6_ADMIN_ROLE
]

export const NON_ADMIN_ROLES = [
    IT_ROLE,
    USER_ROLE,
    NON_GPSC_USER_ROLE,
    ECR_AGENT_USER_ROLE,
    SUPPLYCHAIN_USER_ROLE,
    DOMAIN_4_USER_ROLE
]

export const ADMIN_AND_IT_ROLES = [...ADMIN_ROLES, IT_ROLE]

export const ALL_VALID_ROLES = [
    ...ADMIN_ROLES, ...NON_ADMIN_ROLES
]

export const DOMAIN_ID_ROLE_DICT = new Map<string, string>([
    ["1", PURCHASING_ADMIN_ROLE],
    ["2", SQ_ADMIN_ROLE],
    ["3", SUPPLYCHAIN_ADMIN_ROLE],
    ["4", DOMAIN_4_ADMIN_ROLE],
    ["5", DOMAIN_5_ADMIN_ROLE],
    ["6", DOMAIN_6_ADMIN_ROLE]
])

export const DOMAIN_USER_ROLE_ID_DICT = new Map<string, string>([
    [SUPPLYCHAIN_USER_ROLE, "3"],
    [DOMAIN_4_USER_ROLE, "4"]
])

export const RAG_AGENT = "rag"
export const ECR_AGENT = "ecr"
//export const NL2SQL_AGENT = "nl2sql"

export const MCP_AGENTS = [
    RAG_AGENT,
    ECR_AGENT
]

export const chatBotTipsAndTricks = [
    {
        text: 'Look Up Assigned ECRs: Easily retrieve ECRs assigned to yourself or others using a GMID. Examples: "What ECRs are assigned to me?", "Show me ECRs for [GMID]"',
        component: (
            <Box>
                <Typography variant="h2">
                  Look Up Assigned ECRs
                </Typography>
                <Typography variant="body1">
                  Easily retrieve ECRs assigned to yourself or others using a GMID.
                </Typography>
                <Typography variant="body1" sx={{ mt: 0.5, fontSize: '1.1rem', fontWeight: 600 }}>
                    Examples:
                </Typography>
                <Box component="ul" sx={{ mt: 0.25, pl: 3 }}>
                    <li><Typography variant="body1">What ECRs are assigned to me?</Typography></li>
                    <li><Typography variant="body1">Show me ECRs for [GMID]</Typography></li>
                </Box>
            </Box>
        )
    },
    {
        text: 'Find Similar ECRs: Identify comparable ECRs based on another ECR\'s content to support negotiation and decision-making. Example: "What are some similar ECRs to [insert ECR #]?"',
        component: (
            <Box>
                <Typography variant="h2">
                    Find Similar ECRs
                </Typography>
                <Typography variant="body1">
                    Identify comparable ECRs based on another ECR's content to support negotiation and decision-making.
                </Typography>
                <Typography variant="body1" sx={{ mt: 0.5, fontSize: '1.1rem', fontWeight: 600 }}>
                    Example:
                </Typography>
                <Box component="ul" sx={{ mt: 0.25, pl: 3 }}>
                    <li><Typography variant="body1">What are some similar ECRs to [insert ECR #]?</Typography></li>
                </Box>
            </Box>
        )
    },
    {
        text: 'Get Part Volumes: Find part volumes by ECR or by specific part number. Examples: "What are the volumes for parts on [insert ECR #]?", "What are the volumes for parts [insert part #s]?"',
        component: (
            <Box>
                <Typography variant="h2">
                    Get Part Volumes
                </Typography>
                <Typography variant="body1">
                    Find part volumes by ECR or by specific part number.
                </Typography>
                <Typography variant="body1" sx={{ mt: 0.5, fontSize: '1.1rem', fontWeight: 600 }}>
                    Examples:
                </Typography>
                <Box component="ul" sx={{ mt: 0.25, pl: 3 }}>
                    <li><Typography variant="body1">What are the volumes for parts on [insert ECR #]?</Typography></li>
                    <li><Typography variant="body1">What are the volumes for parts [insert part #s]?</Typography></li>
                </Box>
            </Box>
        )
    },
    {
        text: 'Create Contract Note Templates: Generate contract note templates automatically using ECR numbers. Manual inputs are required. Example: "Contract notes template for ECR [insert ECR #]"',
        component: (
            <Box>
                <Typography variant="h2">
                    Create Contract Note Templates
                </Typography>
                <Typography variant="body1">
                    Generate contract note templates automatically using ECR numbers. Manual inputs are required.
                </Typography>
                <Typography variant="body1" sx={{ mt: 0.5, fontSize: '1.1rem', fontWeight: 600 }}>
                    Example:
                </Typography>
                <Box component="ul" sx={{ mt: 0.25, pl: 3 }}>
                    <li><Typography variant="body1">Contract notes template for ECR [insert ECR #]</Typography></li>
                </Box>
            </Box>
        )
    }
];
export const chatBotInstructions = [
    {
        text: "Please create a test account via tums.gm.com before the UAT test. Your test account is like GMID@NAMQA.CORPQA.GEUC.corp.gm.com.",
        component: (
            <Typography variant="h5">
                Please create a test account via{" "}
                <Link href="https://tums.gm.com" target="_blank" rel="noopener noreferrer">
                    tums.gm.com
                </Link>{" "}
                before the UAT test. Your test account is in the form: <code>GMID@NAMQA.CORPQA.GEUC.corp.gm.com.</code>
            </Typography>
        )
    },
    {
        text: `You need at least to be in the GPSC Users group to chat with ${CHATBOT_WEBSITE_NAME}. Please request access as needed.`,
        component: (
            <Typography variant="h5">
                You need at least to be in the GPSC Users group to chat with <b>{CHATBOT_WEBSITE_NAME}</b>. Please request access as needed.
            </Typography>
        )
    },
    {
        text: "You need to be in the GPSC Admin group to perform the additional Admin tasks. Please request access as needed.",
        component: (
            <Typography variant="h5">You need to be in the GPSC Admin group to perform the additional Admin tasks. Please request access as needed.</Typography>
        )
    }
];
